import { useEffect } from 'react';
import useBusinessStore from '../state/businessStore';
import { fetchBusinesses } from '../api/business';

const useFetchBusinesses = () => {
  const { setBusinesses } = useBusinessStore();

  const fetchAllBusinesses = async () => {
    const userId = Number(localStorage.getItem('sender_id'));

    try {
      const businesses = await fetchBusinesses(userId);
      setBusinesses(businesses);
    } catch (error) {
      console.error('Error fetching businesses:', error);
      setBusinesses([]);
    }
  };

  useEffect(() => {
    fetchAllBusinesses();
  }, [setBusinesses]);

  return { fetchAllBusinesses };
};

export default useFetchBusinesses;
